import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Home from "../Home/Home";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';

const AdminLogin = () => {
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const [openLoader, setOpenLoader] = React.useState(false);

    const message = location.state?.message || "";

    const handleLogin = async () => {
        setOpenLoader(true);
        setErrorMessage("");
        const response = await fetch(process.env.REACT_APP_API_URL + "/user/login", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ userName, password }),
            credentials: "include", // Ensures session cookies are sent
        });

        if (response.ok) {
            setOpenLoader(false);
            const user = await response.json();
            if (user.userRole !== 1 && user.userRole !== 2) {
                setErrorMessage("User doesn't have admin role"); // Show error if user is not admin
                return;
            }
            sessionStorage.setItem("user", JSON.stringify(user));
            navigate("/admin-home"); // Redirect to home page
        } else {
            setOpenLoader(false);
            setErrorMessage("Invalid username or password");
        }
    };

    return (
        <Home>
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={openLoader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
             <div className="container">
                <div className="row">
                    <div className="col-md-4 off offset-md-4 admin_login_form">
                    <h2 style={{ textAlign: "center" }}>Admin Login</h2>
                    {message && <p style={{ color: "red" }}>{message}</p>}
                    <input type="text" placeholder="Username" value={userName} onChange={(e) => setUserName(e.target.value)} />
                    <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                    <div className="button-container">
                        <Button variant="contained" onClick={handleLogin}>Login</Button>
                        <Button variant="contained" onClick={() => { setUserName(""); setPassword(""); setErrorMessage(""); }}
                            >Cancel
                        </Button>
                    </div>
                    {errorMessage && <p style={{ color: "red", marginTop: "10px" }}>{errorMessage}</p>}
                    </div>
                </div>
            </div>
        </Home>
    );
};

export default AdminLogin;
